import { Event } from '@ftr/bus-messages';
export var SessionSttEmissionStatus;
(function (SessionSttEmissionStatus) {
    SessionSttEmissionStatus["Finished"] = "Finished";
})(SessionSttEmissionStatus || (SessionSttEmissionStatus = {}));
export class LiveSttSessionEmissionStatusUpdated extends Event {
    constructor(recordingId, 
    /**
     * One-indexed session number based on the session timeframes in the recording.
     */
    sessionNumber, sessionStatus) {
        super();
        this.recordingId = recordingId;
        this.sessionNumber = sessionNumber;
        this.sessionStatus = sessionStatus;
        this.$name = LiveSttSessionEmissionStatusUpdated.NAME;
        this.$version = 0;
    }
}
LiveSttSessionEmissionStatusUpdated.NAME = 'ftr-regional-api/LiveSttSessionEmissionStatusUpdated';
